import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import ManageCategoryOrder from '../../components/collection/collection-category-order';

const ContentCollectionsCategoryOrder = () => {
  const { id } = useParams();
  const pageTitle = 'Content / Collection';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ManageCategoryOrder id={id} />
    </AppLayout>
  );
};

export default ContentCollectionsCategoryOrder;
